import React from "react";
import "../styles/whatwedo.css"


import {
  PiPlugsConnectedDuotone,
  PiGlobeDuotone,
  PiDeviceMobileDuotone,
  PiCpuDuotone,
  PiGearDuotone,
  PiCloudDuotone,
  PiFlaskDuotone,
  PiHeadsetDuotone
} from "react-icons/pi";


export default function WhatWeDo() {


  const brandColor = "#83b6edff";

  const services = [
    { icon: <PiPlugsConnectedDuotone size={50} color={brandColor} />, title: "IoT Solutions" },
    { icon: <PiGlobeDuotone size={50} color={brandColor} />, title: "Web Development" },
    { icon: <PiDeviceMobileDuotone size={50} color={brandColor} />, title: "Mobile App Development" },
    { icon: <PiCpuDuotone size={50} color={brandColor} />, title: "Hardware Design & Development" },
    { icon: <PiGearDuotone size={50} color={brandColor} />, title: "Electronics Manufacturing" },
    { icon: <PiCloudDuotone size={50} color={brandColor} />, title: "Cloud Integration" },
    { icon: <PiFlaskDuotone size={50} color={brandColor} />, title: "Product Research & Development" },
    { icon: <PiHeadsetDuotone size={50} color={brandColor} />, title: "Technical Support" },
  ];

  return (
    <section className="what-we-do">
      <button className="product-btn">What We Do</button>

      <h2 className="product-title">
        Empowering ideas with  <span className="highlight">intelligent hardware</span> <br></br> and digital experiences.
      </h2>
      <div className="services-grid">
        {services.map((item, index) => (
          <div className="service-card" key={index}>
            <span className="what-icon">{item.icon}</span>
            <h3>{item.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}

